module.exports = {"210881001":"鼓楼街道","210881002":"西城街道","210881003":"东城街道","210881004":"太阳升街道","210881005":"团山街道","210881006":"西海街道","210881007":"九垄地街道","210881008":"归州街道","210881102":"高屯镇","210881105":"沙岗镇","210881109":"九寨镇","210881110":"万福镇","210881111":"卧龙泉镇","210881112":"青石岭镇","210881113":"暖泉镇","210881116":"榜式堡镇","210881117":"团甸镇","210881118":"双台镇","210881119":"杨运镇","210881120":"徐屯镇","210881121":"什字街镇","210881122":"矿洞沟镇","210881123":"陈屯镇","210881124":"梁屯镇","210881216":"小石棚乡","210881217":"果园乡","210881218":"二台乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210881.json
// module id = 562
// module chunks = 0